(() => {
  const bar = document.querySelector('.cxa2-progress span');
  const article = document.querySelector('.article-template');
  if (!bar || !article) return;

  let ticking = false;
  const update = () => {
    const start = article.offsetTop;
    const distance = Math.max(article.offsetHeight - window.innerHeight, 1);
    const progress = Math.min(1, Math.max(0, (window.scrollY - start) / distance));
    bar.style.width = `${progress * 100}%`;
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();
